import Icon from "../../../../../../../components/elements/Icons/Icon"
import "./TargetIcon.css"

export default function TargetIcon({ iconName }) {
    return (
        <div className="target-icon-block">
            <svg className="bg" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="30" cy="30" r="29.5" fill="black" fill-opacity="0.2" stroke="url(#paint0_linear_129_26)"/>
                <defs>
                <linearGradient id="paint0_linear_129_26" x1="66" y1="-1.53065e-06" x2="-19.6" y2="83.6" gradientUnits="userSpaceOnUse">
                <stop stop-color="#F9C49A"/>
                <stop offset="0.524044" stop-opacity="0"/>
                </linearGradient>
                </defs>
            </svg>

            <Icon name={ iconName } color="#FFC0A9" />
        </div>
    )
}